module.exports = __webpack_public_path__ + "0f222713c3ffd660c456e23690caf0a8.svg";